/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import {ErrorBoundary} from "errorboundarys";
import UIElement from "./UIElement.jsx";
import {AnimatePresence} from "motion/react";
import UnmountOnExit from "../UnmountOnExit.jsx";
import useUIGeneratorState from "../../stores/UIGeneratorStore.jsx";
import {useCompare} from "../../hooks/useCompare.jsx";


const UIGenerator = () => {
    const sortedUiIds = useUIGeneratorState(useCompare((state) => state.getSortedIds()));

    return (
        <ErrorBoundary errorStyle={'small'}>
            <AnimatePresence mode={"popLayout"} key={"UIGenerator"}>
                {sortedUiIds.map((uiId) => {
                    return (
                        <UnmountOnExit key={uiId}>
                            <UIElement
                                key={uiId}
                                uiId={uiId}
                            />
                        </UnmountOnExit>
                    );
                })}
            </AnimatePresence>
        </ErrorBoundary>
    );
};
export default UIGenerator;


UIGenerator.propTypes = {
    /**
     * The text of the Button
     */
    text: PropTypes.string.isRequired,
    /**
     * The event if the button is pressed
     * @example (value)=>{console.log(value)}
     */
    onClick: PropTypes.func,
    /**
     * The hover color of the icon
     * @example text-green-500
     * @default text-gray-100
     */
    iconHoverColor: PropTypes.string,
    /*** The color if the button is pressed*  @example bg-green-50*  @default bg-gray-100*/
    activeColor: PropTypes.string,
    /**
     * The color if the button is pressed
     *  @example IoIosAdd
     *  @default IoIosAdd
     */
    iconName: PropTypes.string,


}

UIGenerator.defaultProps = {
    text: '', iconHoverColor: 'text-gray-100', activeColor: 'bg-gray-100', iconName: 'IoIosAdd'
}

